import PersonDetail from "./PersonDetail";

export default PersonDetail;
